import { render, staticRenderFns } from "./CustomerContract.vue?vue&type=template&id=680cf5ef&scoped=true"
import script from "./CustomerContract.vue?vue&type=script&lang=js"
export * from "./CustomerContract.vue?vue&type=script&lang=js"
import style0 from "./CustomerContract.vue?vue&type=style&index=0&id=680cf5ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680cf5ef",
  null
  
)

export default component.exports